import React from 'react';
import MainHeader from './MainHeader';
import ProgramItemBanner, { ProgramItemBannerProps } from './program/ProgramItemBanner';
import ProgramListBanner from './program/ProgramListBanner';
import logo from '../assets/logo.png';
import { COLOR_PRIMARY } from '../const';
import Footer from './Footer';

const propsList: ProgramItemBannerProps[] = [
  {
    imgSrc: logo,
    reverseOrder: false,
    title: '개인수업',
    description: '캥거루짐만의 개인 수업',
    backgroundColor: COLOR_PRIMARY,
  },
  {
    imgSrc: logo,
    reverseOrder: true,
    title: '축구',
    description: '캥거루짐만의 개인 수업',
    backgroundColor: '#ffffff',
  },
  {
    imgSrc: logo,
    reverseOrder: false,
    title: '농구',
    description: '캥거루짐만의 개인 수업',
    backgroundColor: COLOR_PRIMARY,
  },
  {
    imgSrc: logo,
    reverseOrder: true,
    title: '줄넘기',
    description: '캥거루짐만의 개인 수업',
    backgroundColor: '#ffffff',
  },
  {
    imgSrc: logo,
    reverseOrder: false,
    title: '테니스',
    description: '캥거루짐만의 개인 수업',
    backgroundColor: COLOR_PRIMARY,
  },
  {
    imgSrc: logo,
    reverseOrder: true,
    title: '인라인',
    description: '캥거루짐만의 개인 수업',
    backgroundColor: '#ffffff',
  },
  {
    imgSrc: logo,
    reverseOrder: false,
    title: '생활체육',
    description: '캥거루짐만의 개인 수업',
    backgroundColor: COLOR_PRIMARY,
  },
  {
    imgSrc: logo,
    reverseOrder: true,
    title: '기능성 훈련',
    description: '캥거루짐만의 개인 수업',
    backgroundColor: '#ffffff',
  },
]

export default function Program() {
  return (
    <>
      <MainHeader />
      <ProgramListBanner />
      {propsList.map(props => <ProgramItemBanner
        imgSrc={props.imgSrc}
        reverseOrder={props.reverseOrder}
        title={props.title}
        description={props.description}
        backgroundColor={props.backgroundColor}
      />)}
      <Footer />
    </>
  )
}
